/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentInfoDto } from '../../models/document-info-dto';

export interface DocumentsGetDocumentsForCase$Params {
  'x-trace-id'?: string;
  casId: number;
}

export function documentsGetDocumentsForCase(http: HttpClient, rootUrl: string, params: DocumentsGetDocumentsForCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DocumentInfoDto>>> {
  const rb = new RequestBuilder(rootUrl, documentsGetDocumentsForCase.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
    rb.path('casId', params.casId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DocumentInfoDto>>;
    })
  );
}

documentsGetDocumentsForCase.PATH = '/api/documents/case/{casId}';
